import React from 'react';
import ReactDOM from 'react-dom';
import {BrowserRouter as Router} from 'react-router-dom'
import {Provider} from 'react-redux'
import store from './store'
import '@fortawesome/fontawesome-free/css/all.min.css'
import './assets/lib/bootstrap.min.css'
import './style.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {registerServiceWorker} from './pwaRegistration'

ReactDOM.render(
  <Provider store={store}>
    <Router>
      <App />
    </Router>
  </Provider>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()

registerServiceWorker()
